export const PLAN_VALUES = ["general", "curtain", "full"];
export const BILLING_PLAN_VALUES = ["trial", "basic", "standard", "premium", "custom"];
export const ACCOUNT_STATUS_VALUES = [
  "trial",
  "trial_exhausted",
  "active",
  "payment_pending",
  "suspended",
];

export const FEATURE_KEYS = [
  "dashboard",
  "crm",
  "generalQuotes",
  "curtainQuotes",
  "stitchingRates",
  "rollOptimizer",
  "customerPdf",
  "workshopPdf",
  "savedQuotes",
  "settings",
];

export const FEATURE_LABELS = {
  dashboard: "Dashboard",
  crm: "CRM",
  generalQuotes: "General Quotes",
  curtainQuotes: "Curtain Quotes",
  stitchingRates: "Stitching & Rates",
  rollOptimizer: "Roll Optimizer",
  customerPdf: "Customer PDF",
  workshopPdf: "Workshop PDF",
  savedQuotes: "Saved Quotes",
  settings: "Settings",
};

export const LEGACY_FEATURE_ALIASES = {
  general_quotes: "generalQuotes",
  curtain_quotes: "curtainQuotes",
  curtain_stitching_rates: "stitchingRates",
  roll_optimizer: "rollOptimizer",
  customer_pdf: "customerPdf",
  workshop_pdf: "workshopPdf",
  saved_quotes: "savedQuotes",
};

export const LEGACY_PLAN_ALIASES = {
  general_crm_dashboard: "general",
  curtain_crm_dashboard: "curtain",
  full_suite: "full",
};

export const BILLING_PLAN_TO_ACCESS_PLAN = {
  trial: "full",
  basic: "general",
  standard: "full",
  premium: "full",
  custom: "full",
};

export function normalizePlan(plan = "full") {
  const normalized = LEGACY_PLAN_ALIASES[plan] || plan;
  return PLAN_VALUES.includes(normalized) ? normalized : "full";
}

export function normalizeBillingPlan(plan = "trial") {
  const normalized = String(plan || "trial").trim().toLowerCase();
  return BILLING_PLAN_VALUES.includes(normalized) ? normalized : "trial";
}

export function resolveAccessPlan(plan = "full", accessPlan = "") {
  const trimmedAccessPlan = String(accessPlan || "").trim();
  if (trimmedAccessPlan) {
    return normalizePlan(trimmedAccessPlan);
  }
  const normalizedBillingPlan = normalizeBillingPlan(plan);
  if (BILLING_PLAN_TO_ACCESS_PLAN[normalizedBillingPlan]) {
    return BILLING_PLAN_TO_ACCESS_PLAN[normalizedBillingPlan];
  }
  return normalizePlan(plan);
}

export function normalizeAccountStatus(status = "active", fallbackIsActive = true) {
  const normalized = String(status || "").trim().toLowerCase();
  if (ACCOUNT_STATUS_VALUES.includes(normalized)) {
    return normalized;
  }
  return fallbackIsActive === false ? "suspended" : "active";
}

export function isAccountStatusUnlocked(status = "active") {
  return ["trial", "active"].includes(normalizeAccountStatus(status));
}

export function getFeatureAccess(plan) {
  const normalizedPlan = normalizePlan(plan);
  return {
    dashboard: true,
    crm: true,
    generalQuotes: normalizedPlan === "general" || normalizedPlan === "full",
    curtainQuotes: normalizedPlan === "curtain" || normalizedPlan === "full",
    stitchingRates: normalizedPlan === "curtain" || normalizedPlan === "full",
    rollOptimizer: normalizedPlan === "curtain" || normalizedPlan === "full",
    customerPdf: normalizedPlan === "curtain" || normalizedPlan === "full",
    workshopPdf: normalizedPlan === "curtain" || normalizedPlan === "full",
    savedQuotes: true,
    settings: true,
  };
}

export function normalizeFeatureMap(features = {}, plan = "full") {
  const defaults = getFeatureAccess(plan);
  const normalizedInput = Object.entries(features || {}).reduce((next, [key, value]) => {
    const normalizedKey = LEGACY_FEATURE_ALIASES[key] || key;
    return FEATURE_KEYS.includes(normalizedKey)
      ? {
          ...next,
          [normalizedKey]: value === true,
        }
      : next;
  }, {});

  return FEATURE_KEYS.reduce(
    (next, key) => ({
      ...next,
      [key]: normalizedInput[key] != null ? normalizedInput[key] === true : defaults[key],
    }),
    {}
  );
}

export function hasFeatureAccess(features = {}, featureKey) {
  const normalizedKey = LEGACY_FEATURE_ALIASES[featureKey] || featureKey;
  return features?.[normalizedKey] === true;
}
